import PropTypes from 'prop-types';

import {getDisclosureIcon} from '../../../../components/data-disclosure-icon-map';

const DisclosureIcon = (props) => {
  const {disclosureid, disclosuretype} = props;
  const Icon = getDisclosureIcon(disclosureid, disclosuretype, props);

  return Icon;
};

DisclosureIcon.Prototypes = {
  disclosureId: PropTypes.number,
  disclosureType: PropTypes.string,
};

export default DisclosureIcon;
